const pipelinesBasePath = "/pipelines";
const jobsBasePath = "/jobs";
const configurationsBasePath = "/configurations";
const users = "/users";
const authBasePath = "/auth";
const sampleInventoryBasePath = "/sample-inventory/list-files";
const softwareSettingsBasePath = "/software-settings";

// Define the API endpoint routes
export const API_ENDPOINTS = {
  // endpoints specific to Authentication
  oidc: `${authBasePath}/oidc`,
  credentials: `${authBasePath}/credentials`,
  token: `${authBasePath}/token`,
  csfrToken: `${authBasePath}/csrf-token`,

  // endpoints specific to Users
  changeCurrentUserPassword: `${users}/me/password`,

  // endpoints specific to Pipelines
  pipelines: pipelinesBasePath,
  pipelinesId: `${pipelinesBasePath}/{id}`,
  pipelineSteps: `${pipelinesBasePath}/{pipeline_id}/steps`,

  // endpoints specific to Jobs
  jobs: jobsBasePath,
  jobById: `${jobsBasePath}/{job_id}`,
  cancelPendingBatchesByJobId: `${jobsBasePath}/{job_id}/cancel-pending-batches`,
  abortJobById: `${jobsBasePath}/{job_id}/abort`,
  resumeJobById: `${jobsBasePath}/{job_id}/resume`,
  reconfigureJob: `${jobsBasePath}/{job_id}/reconfigure`,
  availableMergeNodePools: `${configurationsBasePath}/merge-node-pools`,
  jobSteps: `${jobsBasePath}/{job_id}/steps`,
  steps: `${jobsBasePath}/{job_id}/steps/{job_pipeline_step_id}`,
  stepBatches: `${jobsBasePath}/{job_id}/steps/{job_pipeline_step_id}/batches`,
  batchLogs: `${jobsBasePath}/{job_id}/steps/{job_pipeline_step_id}/batches/{batch_id}/logs/{session_id}`,
  batchResults: `${jobsBasePath}/{job_id}/steps/{job_pipeline_step_id}/batches/{batch_id}/results/{session_id}`,
  batchArtifactsDownload: `${jobsBasePath}/{job_id}/steps/{job_pipeline_step_id}/batches/{batch_id}/artifacts`,
  batchArtifactsFiles: `${jobsBasePath}/{job_id}/steps/{job_pipeline_step_id}/batches/{batch_id}/artifacts/files`,
  stepResultsDownload: `${jobsBasePath}/{job_id}/steps/{job_pipeline_step_id}/results`,
  stepResultsFiles: `${jobsBasePath}/{job_id}/steps/{job_pipeline_step_id}/results/files`,
  stepBatchSamples: `${jobsBasePath}/{job_id}/steps/{job_pipeline_step_id}/batches/{batch_id}/samples`,

  //endpoints specific to Software Settings
  softwareSettings: softwareSettingsBasePath,
  softwareSettingsUpload: `${softwareSettingsBasePath}/{software}/{version}/create/{type}`,
  softwareSettingsDicriminator: `${softwareSettingsBasePath}/discriminator/{discriminator}`,

  //endpoints specific to Software Versions
  softwareVersions: `/software-versions`,
  softwareVersionsVersion: `/software-versions/{version}`,

  //endpoints specific to Fasta
  fastaListFiles: "/fasta/list-files",
  fasta: "/fasta",

  // endpoints specific to Inventory, which is for rawFiles and instruments.
  rawFiles: sampleInventoryBasePath,
  rawFilesBatch: `${sampleInventoryBasePath}/batch/{ids}`,
  rawFilesUpload: "/sample-inventory/upload",
  rawFilesUploadInit: "/sample-inventory/upload/init",
  rawFilesUploadChunk: "/sample-inventory/upload/chunk",
  rawFilesUploadComplete: "/sample-inventory/upload/complete",
  checkFile: "/sample-inventory/check",
  checkFiles: "/sample-inventory/check-batch",
  rawFilesDelete: "/sample-inventory/files",
  rawFilesUsage: "/sample-inventory/usage",
  instruments: `${sampleInventoryBasePath}/instruments`,

  // storage locations resolved by the backend (container on Azure, folder prefix on AWS)
  storageLocations: "/storage-locations",

  // websocket endpoints
  jobsHub: "/hubs/jobs",
  logsHub: "/hubs/logs",

  // license endpoint
  license: "/license",
  licenseStatus: "/license/status",

  // results endpoint
  resultsS3Download: "/jobs/{job_id}/results",
  resultsS3Files: "/jobs/{job_id}/results/files",
  // endpoints specific to Libraries
  libraries: "/libraries/list-files",
  librariesUpload: "/libraries/upload",
  librariesUploadInit: "/libraries/upload/init",
  librariesUploadChunk: "/libraries/upload/chunk",
  librariesUploadComplete: "/libraries/upload/complete",
  // endpoints specific to Archives
  archives: "/archives/list-files",
  archivesJobs: "/archives/jobs",
};
